import { loadingHtml } from "./virtual";
import { cr } from "fire-wind-water";

class SkLoading {
  private elem: HTMLElement;

  static intactHtml(o: { [label: string]: any }[], h: string): string {
    let s = "";
    cr.each(o, (d) => {
      s += `<${d.h} class="${d.c}" ${d.id ? 'id="' + d.id + '"' : ""}>`;
      if (d.s) {
        s += SkLoading.intactHtml(d.s, h);
      }
      if (d.lf) {
        s += d.lf(h);
      }
      s += `</${d.h}>`;
    });
    return s;
  }

  getHtml(s?: string): string {
    const str = SkLoading.intactHtml(loadingHtml, s);
    return str;
  }

  static create(dom: any, s: string): HTMLElement {
    const elem: HTMLElement = SkLoading.createVirtual(loadingHtml, {
      loading: s,
    })[0];
    const parent: HTMLElement = SkLoading.isParent(dom);
    parent.appendChild(elem);
    return elem;
  }

  static isParent(s: any): HTMLElement {
    let parent: HTMLElement;
    if (cr.isString(s)) {
      parent = document.querySelector(s);
    } else if (
      s &&
      typeof s === "object" &&
      s.nodeType === 1 &&
      typeof s.nodeName === "string"
    ) {
      parent = s;
    }
    return parent || document.body;
  }

  static createVirtual(
    a: { [label: string]: any },
    sett: { [label: string]: any }
  ): HTMLElement[] {
    const arr: HTMLElement[] = [];
    cr.each(a, (o) => {
      const el = document.createElement(o.h);
      el.className = o.c;
      if (o.id) {
        el.id = o.id;
      }
      if (o.lf) {
        el.innerHTML = o.lf(sett.loading);
      }
      if (o.s) {
        const c = this.createVirtual(o.s, sett);
        cr.each(c, (d) => {
          el.appendChild(d);
        });
      }
      arr.push(el);
    });
    return arr;
  }

  show(o?: { [label: string]: any }): any {
    const sett = {
      dom: o ? o.dom : null,
      val: o ? o.html : undefined,
    };
    this.hide();
    this.elem = SkLoading.create(sett.dom, sett.val);
    if (sett.dom) {
      this.elem.style.position = "absolute";
    }
    return this;
  }

  hide(): void {
    if (!this.elem) {
      return;
    }
    this.elem.parentNode.removeChild(this.elem);
    this.elem = null;
  }
}

const loading = new SkLoading();
export { SkLoading, loading };
